<template>
  <div class="goods_detail">
    <!-- 页面loading -->
    <loading v-show="ifShowLoading" />
    <div class="header">
      <!-- 头部logo -->
      <div class="header_img"></div>
      <div class="search_btn">
        <!-- tab标签页 -->
        <van-tabs v-model="active" swipeable animated>
          <van-tab title="箱码">
            <!-- 箱码组件 -->
            <one-goods-info :oneBox="oneBox" />
          </van-tab>
          <van-tab title="发货单">
            <!-- 发货单组件 -->
            <all-goods-info :allBox="allBox" />
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
// import goodsInfo from "@/components/goodsInfo.vue";
import oneGoodsInfo from "../../components/oneGoodsInfo.vue";
import allGoodsInfo from "../../components/allGoodsInfo.vue";
import Loading from "../../components/Loading.vue";
import {
  getPackageInfoByPackageId,
  getPackageInfoByInvoiceId,
} from "../../../api/index";
export default {
  components: { oneGoodsInfo, Loading, allGoodsInfo },
  data() {
    return {
      selectData: [
        { name: "按发货单查询", code: 0 },
        { name: "按箱查询", code: 0 },
      ],
      active: 0,
      oneBox: {},
      allBox: {},
      ifShowLoading: false,
    };
  },
  created() {
    console.log("路由接受参数", this.$route);
    this.boxInit();
  },
  methods: {
    boxInit() {
      console.log('boxInit')
      // alert(this.$route.query.code);
      // this.$route.query.code = "1777254212191784960";
      // alert(this.$route.query.id);
      if (this.$route.query.id) {
        this.ifShowLoading = true;
        getPackageInfoByPackageId({ id: this.$route.query.id })
          .then((res) => {
            if (res.code === 0) {
              this.ifShowLoading = false;
              this.oneBox = res.dataInfo;
            } else {
              this.ifShowLoading = false;
            }
          })
          .catch((error) => {
            this.ifShowLoading = false;
          });
      }
    },
    deliveryInit() {
      console.log('deliveryInit')
      let _this = this;
      // console.log("oneBox", _this.oneBox);
      this.ifShowLoading = true;
      getPackageInfoByInvoiceId({ id: this.oneBox.invoiceId })
        .then((res) => {
          if (res.code === 0) {
            this.ifShowLoading = false;
            this.allBox = res.dataInfo;
          } else {
            this.ifShowLoading = false;
          }
        })
        .catch((error) => {
          this.ifShowLoading = false;
        });
    },
  },
  watch: {
    active(value) {
      if (value == 0) {
        this.boxInit();
      } else {
        this.deliveryInit();
      }

      // console.log("value", value);
    },
  },
};
</script>

<style scoped>
.goods_detail {
  /* background-color: #f5f6f8; */
  /* height: 1000px; */
  padding-bottom: 20px;
  overflow-y: auto;
}
.header_img {
  background: url("../../assets/qrCodeImg/headerImg.png") no-repeat;
  background-size: 100% 100%;
  width: 137px;
  height: 32px;
  margin: 20px auto;
}
.search_btn {
  /* width: 94%; */
  /* background-color: #f5f5f5; */
  /* font-size: 20px; */
  padding: 5px 0;
  margin: 20px auto;
  border-radius: 5px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/scanQrCodes/goodsDetailList.vue